import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  static isIE() {
    return window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
  }
}
